<template>
  <div class="search-criteria-box">
    <h4 class="tit-search-type is-bgc-red400">奥行</h4>
    <!-- <img src="/images/cmn/ico-depth.png" class="img-fluid mx-auto" alt="" width="300" height="200"> -->

    <div class="search-radio-set">
      <template v-for="option in options">
        <input type="radio"
        :name="name"
        :id="`label4-${option.id}`"
        :key="`radio4-${option.id}`"
        :value="option.data"
        @change="updateValue(option.data, option.flag)"
        v-bind:disabled="flag[option.id]==false"
        >
        <label :key="`label4-${option.id}`" :for="`label4-${option.id}`" v-html="option.value"></label>
    </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
    options: { type: Array },
    name: { type: String },
    flag: { type: Object },
  },
  methods: {
    updateValue: function(value, flag) {
      this.$emit('DepthFlag', flag);
      this.$emit("input", value);
    }
  }
}
</script>